import axios from '../../axios'
import {GET_CATEGORY_LIST, GET_SERVICE_LIST_BY_CATEGORY,ADD_SERVICE,ADD_CATEGORY, UPDATE_CATEGORY,GET_SERVICE_LIST,
  DELETE_CATEGORY, UPDATE_SERVICE, DELETE_SERVICE,GET_ACTIVE_CATEGORY,MOVE_CATEGORY,GET_CATEGORY_LIST_ALL,GET_SERVICE_INFO, DRAG_CATEGORY,
  IMPORT_SERVICE, DRAG_SERVICE, GET_CATEGORY_LIST_BY_TYPE, GET_SERVICE_LIST_POS, GET_PRODUCT_LIST_POS,
  ADD_PRODUCT_POS, UPDATE_PRODUCT_POS, ADD_SERVICE_POS, UPDATE_SERVICE_POS, DELETE_PRODUCT_POS, DELETE_SERVICE_POS, GET_COMBO_LIST_POS, ADD_COMBO_POS, DELETE_COMBO_POS,
  UPDATE_COMBO_POS, GET_ALL_CATEGORY_LIST, DRAG_PRODUCT, GET_GIFTCARD_LIST, GET_GIFTCARD_DETAIL, DOWNLOAD_GIFTCARD_TEMPLATE, EXPORT_GIFTCARD, IMPORT_GIFTCARD, CREATE_GIFTCARD, MULTI_CREATE_GIFTCARD, GET_COMBO_LIST_ACTIVE,
  GET_FULL_CATEGORY_SERVICE_LIST} from './serviceListTypes'

import {URL_GET_CATEGORY_LIST, URL_GET_SERVICE_LIST_BY_CATEGORY,URL_ADD_SERVICE,URL_ADD_CATEGORY, URL_UPDATE_CATEGORY,
  URL_DELETE_CATEGORY, URL_UPDATE_SERVICE, URL_DELETE_SERVICE,URL_GET_SERVICE_LIST,URL_MOVE_CATEGORY,URL_GET_SERVICE_INFO,
  URL_DRAG_CATEGORY, URL_IMPORT_SERVICE, URL_DRAG_SERVICE, URL_GET_CATEGORY_LIST_BY_TYPE,
  URL_GET_SERVICE_LIST_POS, URL_GET_PRODUCT_LIST_POS, URL_ADD_PRODUCT_POS, URL_UPDATE_PRODUCT_POS, URL_ADD_SERVICE_POS, URL_UPDATE_SERVICE_POS,
  URL_DELETE_PRODUCT_POS, URL_DELETE_SERVICE_POS, URL_GET_COMBO_LIST_POS, URL_ADD_COMBO_POS, URL_DELETE_COMBO_POS, URL_UPDATE_COMBO_POS, URL_GET_ALL_CATEGORY_LIST, URL_DRAG_PRODUCT,
  URL_GET_GIFTCARD_LIST, URL_GET_GIFTCARD_DETAIL, URL_DOWNLOAD_GIFTCARD_TEMPLATE, URL_EXPORT_GIFTCARD, URL_IMPORT_GIFTCARD, URL_CREATE_GIFTCARD, URL_MULTI_CREATE_GIFTCARD, URL_GET_COMBO_LIST_ACTIVE,
  URL_GET_FULL_CATEGORY_SERVICE_LIST} from './serviceListUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
// import { dirname } from 'path'

export default {

  [GET_CATEGORY_LIST]({ commit, dispatch }, item) {
    // let param = new URLSearchParams({page:item.page,'per-page': item['per-page']}).toString();
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CATEGORY_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CATEGORY_LIST, data);
              // if(data && data.items && data.items.length > 0) {
              //   for(let i = 0; i < data.items.length; i++) {
              //     if(data.items[i].type == 'combo') {
              //       let temp = {
              //         category_id: data.items[i].id,
              //         status: 1
              //       }
              //       dispatch(GET_COMBO_LIST_ACTIVE, temp);
              //       break;
              //     }
              //   }
              // }
              resolve(data);
            } else {
              commit(GET_CATEGORY_LIST, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_CATEGORY_LIST, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
          // if(response.data.result !== null){
          // //   commit(GET_CATEGORY_LIST,{items: [], _links: {}, _meta: {}})
          // //   resolve({items: [], _links: {}, _meta: {}})
          // // }else{
          //   commit(GET_CATEGORY_LIST, response.data.result.data)
          //   resolve(response)
          // } else {
          //   commit(GET_CATEGORY_LIST, {items: [], _links: {}, _meta: {}});
          //   resolve({items: [], _links: {}, _meta: {}})
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_SERVICE_INFO]({ commit } ,item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SERVICE_INFO}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SERVICE_INFO, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // commit(GET_SERVICE_INFO, response.data.result.data)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_SERVICE_LIST]({ commit } ,item) {
    let param = new URLSearchParams({page:item.page,'per-page': item['per-page']}).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SERVICE_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SERVICE_LIST, data);
              resolve(data);
            } else {
              commit(GET_SERVICE_LIST, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_SERVICE_LIST, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
          // commit(GET_SERVICE_LIST, response.data.result.data)
          // resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_ALL_CATEGORY_LIST]({ commit } , item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_ALL_CATEGORY_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_ALL_CATEGORY_LIST, data);
              resolve(data);
            } else {
              commit(GET_ALL_CATEGORY_LIST, []);
              resolve([]);
            }
          } else {
            commit(GET_ALL_CATEGORY_LIST, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_CATEGORY_LIST_ALL]({ commit } , item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CATEGORY_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CATEGORY_LIST_ALL, data);
              resolve(data);
            } else {
              commit(GET_CATEGORY_LIST_ALL, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_CATEGORY_LIST_ALL, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
          // if(response.data.result !== null) {
          //   commit(GET_CATEGORY_LIST_ALL, response.data.result.data)
          //   resolve(response)
          // } else {
          //   commit(GET_CATEGORY_LIST_ALL, {items: [], _links: {}, _meta: {}})
          //   resolve({items: [], _links: {}, _meta: {}})
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_ACTIVE_CATEGORY]({commit} , item) {
    commit(GET_ACTIVE_CATEGORY, item)
  },

  [GET_SERVICE_LIST_BY_CATEGORY]({ commit } ,item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SERVICE_LIST_BY_CATEGORY}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SERVICE_LIST_BY_CATEGORY, data);
              resolve(data);
            } else {
              commit(GET_SERVICE_LIST_BY_CATEGORY, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_SERVICE_LIST_BY_CATEGORY, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_FULL_CATEGORY_SERVICE_LIST]({ commit, dispatch } ,item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_FULL_CATEGORY_SERVICE_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_FULL_CATEGORY_SERVICE_LIST, data);
              if(data && data.length > 0) {
                let combo = data.find((cate) => cate.type == "combo");
                if(combo) {
                  dispatch(GET_COMBO_LIST_ACTIVE, { category_id: combo.id, status: 1 });
                }
              }
              resolve(data);
            } else {
              commit(GET_FULL_CATEGORY_SERVICE_LIST, []);
              resolve([]);
            }
          } else {
            commit(GET_FULL_CATEGORY_SERVICE_LIST, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [ADD_CATEGORY]({dispatch }, item) {
  let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_CATEGORY}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              const temp = {
                // type: item.type,
                status: item.statusFilter
              }
              // if(item.list_type) {
              //   temp.type = item.list_type;
              // }
              dispatch(GET_CATEGORY_LIST, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  // type: item.type,
                  status: item.statusFilter
                }
                // if(item.list_type) {
                //   temp.type = item.list_type;
                // }
                dispatch(GET_CATEGORY_LIST, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_CATEGORY]({dispatch}, item) {
    let data = new FormData();
    for (var key in item) {
      data.append(key, item[key]);
    }
    let param = new URLSearchParams({id:item.id}).toString();
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_CATEGORY}${param}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              const temp = {
                // type: item.type,
                status: item.statusFilter
              }
              // if(item.list_type) {
              //   temp.type = item.list_type;
              // }
              dispatch(GET_CATEGORY_LIST, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  // type: item.type,
                  status: item.statusFilter
                }
                // if(item.list_type) {
                //   temp.type = item.list_type;
                // }
                dispatch(GET_CATEGORY_LIST, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [DELETE_CATEGORY]({dispatch}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_CATEGORY}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              const temp = {
                // type: item.type,
                status: item.statusFilter
              }
              // if(item.list_type) {
              //   temp.type = item.list_type;
              // }
              dispatch(GET_CATEGORY_LIST, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [ADD_SERVICE]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_SERVICE}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_SERVICE_LIST_BY_CATEGORY, item);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_SERVICE]({ dispatch }, item) {
    let bodyFormData = new FormData();
    for(var key in item){
      bodyFormData.append(key, item[key])
    }
    let param = new URLSearchParams({id:item.id}).toString();
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_SERVICE}${param}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                id: item.category_id
              }
              dispatch(GET_SERVICE_LIST_BY_CATEGORY , temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [DELETE_SERVICE]({dispatch}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_SERVICE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              let temp = {
                id: item.category_id ? item.category_id : 999999
              }
              dispatch(GET_SERVICE_LIST_BY_CATEGORY , temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [MOVE_CATEGORY]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_MOVE_CATEGORY}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CATEGORY_LIST);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [DRAG_CATEGORY]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DRAG_CATEGORY}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   // type: item.type,
              //   status: item.statusFilter
              // }
              // if(item.list_type) {
              //   temp.type = item.list_type;
              // }
              // dispatch(GET_CATEGORY_LIST, temp);
              // dispatch(GET_CATEGORY_LIST_ALL, {"per-page" : 50});
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [DRAG_SERVICE]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DRAG_SERVICE}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // let temp = {
              //   id: item.cate_id ? item.cate_id : 999999
              // }
              // dispatch(GET_SERVICE_LIST_BY_CATEGORY, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [DRAG_PRODUCT]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DRAG_PRODUCT}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [IMPORT_SERVICE]({}, file){
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append('file', file);
      form.append('type', 'service');
      axios.post(URL_IMPORT_SERVICE, form, {headers: {
        'Content-Type': 'multipart/form-data'
      }})
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              console.log()
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [GET_CATEGORY_LIST_BY_TYPE]({ commit } ,item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CATEGORY_LIST_BY_TYPE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CATEGORY_LIST_BY_TYPE, data);
              resolve(data);
            } else {
              commit(GET_CATEGORY_LIST_BY_TYPE, []);
              resolve([]);
            }
          } else {
            commit(GET_CATEGORY_LIST_BY_TYPE, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // [ADD_CATEGORY_POS]({dispatch }, item) {
  //   let bodyFormData = new FormData();
  //   for(let key in item){
  //     bodyFormData.append(key, item[key])
  //   }
  //   return new Promise((resolve, reject) => {
  //     axios.post(`${URL_ADD_CATEGORY_POS}`, bodyFormData)
  //       .then((response) => {
  //         let responseModel = new ResponseModel(response);
  //         if(responseModel.status == STATUS_OK) {
  //           let resultModel = responseModel.result;
  //           if(resultModel.status == STATUS_OK) {
  //             let data = resultModel.data;
  //             const temp = {
  //               // type: item.type,
  //               status: item.statusFilter
  //             }
  //             if(item.type) {
  //               temp.type = item.type;
  //             }
  //             // dispatch(GET_CATEGORY_LIST_BY_TYPE, temp);
  //             // dispatch(GET_ALL_CATEGORY_LIST, temp);
  //             dispatch(GET_CATEGORY_LIST, temp);
  //             resolve(data);
  //           } else {
  //             if(resultModel.message && resultModel.message.name) {
  //               reject(resultModel.message.name[0]);
  //             } else {
  //               let data = resultModel.data;
  //               const temp = {
  //                 // type: item.type,
  //                 status: item.statusFilter
  //               }
  //               if(item.type) {
  //                 temp.type = item.type;
  //               }
  //               // dispatch(GET_CATEGORY_LIST_BY_TYPE, temp);
  //               // dispatch(GET_ALL_CATEGORY_LIST, temp);
  //               dispatch(GET_CATEGORY_LIST, temp);
  //               resolve(data);
  //             }
  //           }
  //         } else {
  //           reject(responseModel.message);
  //         }
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  // [UPDATE_CATEGORY_POS]({dispatch }, item) {
  //   let bodyFormData = new FormData();
  //   for(let key in item){
  //     bodyFormData.append(key, item[key])
  //   }
  //   let param = new URLSearchParams({id:item.id}).toString();
  //   return new Promise((resolve, reject) => {
  //     axios.post(`${URL_UPDATE_CATEGORY_POS}${param}`, bodyFormData)
  //       .then((response) => {
  //         let responseModel = new ResponseModel(response);
  //         if(responseModel.status == STATUS_OK) {
  //           let resultModel = responseModel.result;
  //           if(resultModel.status == STATUS_OK) {
  //             let data = resultModel.data;
  //             const temp = {
  //               // type: item.type,
  //               status: item.statusFilter
  //             }
  //             if(item.type) {
  //               temp.type = item.type;
  //             }
  //             // dispatch(GET_CATEGORY_LIST_BY_TYPE, temp);
  //             // dispatch(GET_ALL_CATEGORY_LIST, temp);
  //             dispatch(GET_CATEGORY_LIST, temp);
  //             resolve(data);
  //           } else {
  //             if(resultModel.message && resultModel.message.name) {
  //               reject(resultModel.message.name[0]);
  //             } else {
  //               let data = resultModel.data;
  //               const temp = {
  //                 // type: item.type,
  //                 status: item.statusFilter
  //               }
  //               if(item.type) {
  //                 temp.type = item.type;
  //               }
  //               // dispatch(GET_CATEGORY_LIST_BY_TYPE, temp);
  //               // dispatch(GET_ALL_CATEGORY_LIST, temp);
  //               dispatch(GET_CATEGORY_LIST, temp);
  //               resolve(data);
  //             }
  //           }
  //         } else {
  //           reject(responseModel.message);
  //         }
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
  // [DELETE_CATEGORY_POS]({dispatch}, item) {
  //   let param = new URLSearchParams(item).toString();
  //   return new Promise((resolve, reject) => {
  //     axios.get(`${URL_DELETE_CATEGORY_POS}${param}`)
  //       .then((response) => {
  //         let responseModel = new ResponseModel(response);
  //         if(responseModel.status == STATUS_OK) {
  //           let resultModel = responseModel.result;
  //           if(resultModel.status == STATUS_OK) {
  //             let data = resultModel.data;
  //             const temp = {
  //               // type: item.type,
  //               status: item.statusFilter
  //             }
  //             if(item.type) {
  //               temp.type = item.type;
  //             }
  //             // dispatch(GET_CATEGORY_LIST_BY_TYPE, temp);
  //             // dispatch(GET_ALL_CATEGORY_LIST, temp);
  //             dispatch(GET_CATEGORY_LIST, temp);
  //             resolve(data);
  //           } else {
  //             reject(resultModel.message);
  //           }
  //         } else {
  //           reject(responseModel.message);
  //         }
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },

  [GET_SERVICE_LIST_POS]({ commit } ,item) {
    let temp = {
      category_id: item.category_id
    }
    if (item.category_id == undefined){
      temp= {};
    }
    if(item.status != 2){
      temp.status = item.status
    }
    let param = new URLSearchParams(temp).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SERVICE_LIST_POS}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SERVICE_LIST_POS, data);
              resolve(data);
            } else {
              commit(GET_SERVICE_LIST_POS, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_SERVICE_LIST_POS, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [ADD_SERVICE_POS]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_SERVICE_POS}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   category_id: item.category_id,
              //   status: item.statusFilter
              // }
              // dispatch(GET_SERVICE_LIST_POS, temp);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [UPDATE_SERVICE_POS]({ dispatch }, item) {
    let bodyFormData = new FormData();
    for(var key in item){
      bodyFormData.append(key, item[key])
    }
    let param = new URLSearchParams({id:item.id}).toString();
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_SERVICE_POS}${param}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   category_id: item.category_id,
              //   status: item.statusFilter
              // }
              // dispatch(GET_SERVICE_LIST_POS , temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [DELETE_SERVICE_POS]({dispatch}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_SERVICE_POS}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              const temp = {
                category_id: item.category_id,
                status: item.statusFilter
              }
              dispatch(GET_SERVICE_LIST_POS , temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_PRODUCT_LIST_POS]({ commit } ,item) {
    const temp = {
      category_id: item.category_id
    }
    if(item.status != 2){
      temp.status = item.status
    }
    let param = new URLSearchParams(temp).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_PRODUCT_LIST_POS}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_PRODUCT_LIST_POS, data);
              resolve(data);
            } else {
              commit(GET_PRODUCT_LIST_POS, []);
              resolve([]);
            }
          } else {
            commit(GET_PRODUCT_LIST_POS, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [ADD_PRODUCT_POS]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_PRODUCT_POS}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   category_id: item.category_id,
              //   status: item.statusFilter
              // }
              // dispatch(GET_PRODUCT_LIST_POS, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  category_id: item.category_id,
                  status: item.statusFilter
                }
                dispatch(GET_PRODUCT_LIST_POS, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_PRODUCT_POS]({dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_PRODUCT_POS}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   category_id: item.category_id,
              //   status: item.statusFilter
              // }
              // dispatch(GET_PRODUCT_LIST_POS, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  category_id: item.category_id,
                  status: item.statusFilter
                }
                dispatch(GET_PRODUCT_LIST_POS, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [DELETE_PRODUCT_POS]({dispatch}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_PRODUCT_POS}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              const temp = {
                category_id: item.category_id,
                status: item.statusFilter
              }
              dispatch(GET_PRODUCT_LIST_POS , temp)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_COMBO_LIST_POS]({ commit } ,item) {
    const temp = {
      category_id: item.category_id
    }
    if(item.status != 2){
      temp.status = item.status
    }
    let param = new URLSearchParams(temp).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_COMBO_LIST_POS}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_COMBO_LIST_POS, data);
              resolve(data);
            } else {
              commit(GET_COMBO_LIST_POS, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_COMBO_LIST_POS, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [ADD_COMBO_POS]({dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_ADD_COMBO_POS}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   category_id: item.category_id,
              //   status: item.statusFilter
              // }
              // dispatch(GET_COMBO_LIST_POS, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  category_id: item.category_id,
                  status: item.statusFilter
                }
                dispatch(GET_COMBO_LIST_POS, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_COMBO_POS]({dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_COMBO_POS}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // const temp = {
              //   category_id: item.category_id,
              //   status: item.statusFilter
              // }
              // dispatch(GET_COMBO_LIST_POS, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  category_id: item.category_id,
                  status: item.statusFilter
                }
                dispatch(GET_COMBO_LIST_POS, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [DELETE_COMBO_POS]({dispatch }, item) {
    const data = {
      id: item.id,
      status: item.status
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DELETE_COMBO_POS}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              const temp = {
                category_id: item.category_id,
                status: item.statusFilter
              }
              dispatch(GET_COMBO_LIST_POS, temp);
              resolve(data);
            } else {
              if(resultModel.message && resultModel.message.name) {
                reject(resultModel.message.name[0]);
              } else {
                let data = resultModel.data;
                const temp = {
                  category_id: item.category_id,
                  status: item.statusFilter
                }
                dispatch(GET_COMBO_LIST_POS, temp);
                resolve(data);
              }
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_GIFTCARD_LIST]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_GIFTCARD_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_GIFTCARD_LIST, data);
              resolve(data);
            } else {
              commit(GET_GIFTCARD_LIST, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_GIFTCARD_LIST, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_GIFTCARD_DETAIL]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_GIFTCARD_DETAIL}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_GIFTCARD_DETAIL, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // eslint-disable-next-line
  [DOWNLOAD_GIFTCARD_TEMPLATE] ({commit},item) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DOWNLOAD_GIFTCARD_TEMPLATE}`, { responseType: 'blob' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error);reject(error) })
    })
  },

  // eslint-disable-next-line
  [EXPORT_GIFTCARD] ({commit},item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_GIFTCARD}${param}`, { responseType: 'blob' })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error);reject(error) })
    })
  },

  [IMPORT_GIFTCARD]({ dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_IMPORT_GIFTCARD}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.error);
            }
          } else {
            reject(responseModel.error);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [CREATE_GIFTCARD]({ dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CREATE_GIFTCARD}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.error);
            }
          } else {
            reject(responseModel.error);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [MULTI_CREATE_GIFTCARD]({ dispatch }, item) {
    let bodyFormData = new FormData();
    for(let key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_MULTI_CREATE_GIFTCARD}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.error);
            }
          } else {
            reject(responseModel.error);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_COMBO_LIST_ACTIVE]({ commit } ,item) {
    const temp = {
      category_id: item.category_id
    }
    if(item.status != 2){
      temp.status = item.status
    }
    let param = new URLSearchParams(temp).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_COMBO_LIST_ACTIVE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_COMBO_LIST_ACTIVE, data);
              resolve(data);
            } else {
              commit(GET_COMBO_LIST_ACTIVE, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_COMBO_LIST_ACTIVE, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}
